module.exports = __webpack_public_path__ + "images/videoCaseStudy-urbanPartnershipBank-whyus-photo-03.jpg?h=f217daed592357bde39c5b495fe2a237";


//////////////////
// WEBPACK FOOTER
// ./src/theme/images/videoCaseStudies/urbanPartnershipBank/videoCaseStudy-urbanPartnershipBank-whyus-photo-03.jpg
// module id = 2131
// module chunks = 12 15